// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","actionRow":"Footer_actionRow__LBDdX","text":"Footer_text__bMQOQ","blue":"Footer_blue__VwccJ","bottomNavgigation":"Footer_bottomNavgigation__PEoeL"};